/** @format */

export interface PaymentsAddress {
  address: string;
  address2?: string;
  city: string;
  country: string;
  email: string;
  first_name: string;
  last_name: string;
  phone: string;
  state: string;
  zipcode: string;
}

export interface PaymentMethod {
  accountSummary?: string;
  paymentMethod:
    | 'PayPal'
    | 'billMeLater'
    | 'creditCard'
    | 'giftCard'
    | 'giftCard - Paygate'
    | 'giftCard - ValueLink'
    | 'Affirm'
    | 'Resiliency';
  paymentMethodDisplay?: string;
  savedIndicator?: string;
}
export interface AuthorizationResponse {
  authorizationResponse: {
    errors?: PaymentError[];
    message?: string;
    paygateReference?: string;
    paymentMethods: PaymentMethod[];
    status: string;
  };
}

export interface PaymentError {
  code: string;
  display?: string;
  message: string;
  systemError: string;
}

export interface QueryParameters {
  [key: string]: string;
}
